import { Component, Input, OnInit, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Table } from 'primeng/table';

import { Product } from 'src/app/shared/product';
import { ProductSerialHistory } from 'src/app/shared/product';
import { ProductApiService } from 'src/app/services/product-api.service';

@Component({
  selector: 'app-product-serials-table',
  templateUrl: './product-serials-table.component.html',
  styleUrl: './product-serials-table.component.css',
  encapsulation: ViewEncapsulation.None
})
export class ProductSerialsTableComponent implements OnInit, OnDestroy {

  @Input() product: Product;

  serialsData: ProductSerialHistory[] | null = null;
  isLoading: boolean = false;

  serialNumberFilter: string = '';
  incomeOrderFilter: string = '';
  incomeSpecFilter: string = '';
  outcomeOrderFilter: string = '';
  outcomeSpecFilter: string = '';
  outcomeSpecDateFilter: string = '';
  invoiceFilter: string = '';
  statusFilter: string = '';

  selectedStatus: string = '';
  statusOptions = [
    { label: 'All', value: '' },
    { label: 'IN_STOCK', value: 'IN_STOCK' },
    { label: 'SHIPPED', value: 'SHIPPED' },
    { label: 'SHIPPED_NO_RECORDED_INCOME', value: 'SHIPPED_NO_RECORDED_INCOME' },
    { label: 'UNLINKED', value: 'UNLINKED' }
  ];

  @ViewChild('serialsTable') serialsTable: Table;

  private destroy$ = new Subject<void>();

  constructor(private prodApi: ProductApiService) { }

  ngOnInit(): void {
    if (this.product?.PRODID) {
      this.loadSerials();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadSerials(): void {
    if (!this.product?.PRODID) { return; }

    this.isLoading = true;
    this.serialsData = null;

    this.prodApi.getProductSerials(this.product.PRODID)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: ProductSerialHistory[]) => {
          this.serialsData = data || [];
          this.isLoading = false;
        },
        error: () => {
          this.serialsData = [];
          this.isLoading = false;
        }
      });
  }

  onRefresh(): void {
    this.loadSerials();
  }

  onStatusFilterChange(event: any): void {
    this.selectedStatus = event.value;
    if (this.serialsTable) {
      this.serialsTable.filter(event.value, 'SerialStatus', event.value ? 'equals' : 'in');
    }
  }

  getStatusBadgeSeverity(status: string): string {
    switch (status) {
      case 'IN_STOCK':
        return 'success';
      case 'SHIPPED':
        return 'info';
      case 'SHIPPED_NO_RECORDED_INCOME':
        return 'warning';
      case 'UNLINKED':
        return 'danger';
      default:
        return 'secondary';
    }
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'IN_STOCK':
        return 'In Stock';
      case 'SHIPPED':
        return 'Shipped';
      case 'SHIPPED_NO_RECORDED_INCOME':
        return 'Shipped (No Income)';
      case 'UNLINKED':
        return 'Unlinked — Review';
      default:
        return status;
    }
  }

  formatDate(dateStr: string | null): string {
    if (!dateStr) { return '—'; }
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('uk-UA', { year: 'numeric', month: '2-digit', day: '2-digit' });
    } catch {
      return dateStr;
    }
  }
}
